import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import { Card } from 'app/components/domain/card/card';

import styles from './card-placeholder.module.scss';

interface Props {
    className?: string;
    descriptionCount: number;
}

export const CardPlaceholder: React.FC<Props> = (props) => {
    const { className, descriptionCount } = props;

    return (
        <div className={classNames(styles.container, className)}>
            <Card>
                <div className={styles.title} />
                {_.range(descriptionCount).map((index) => (
                    <div className={styles.description} key={index} />
                ))}
            </Card>
        </div>
    );
};
